import { render, staticRenderFns } from "./InboxName.vue?vue&type=template&id=43143b0c&scoped=true&"
import script from "./InboxName.vue?vue&type=script&lang=js&"
export * from "./InboxName.vue?vue&type=script&lang=js&"
import style0 from "./InboxName.vue?vue&type=style&index=0&id=43143b0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43143b0c",
  null
  
)

export default component.exports